module.exports = __webpack_public_path__ + "img/skype.ef4b6b18.png";